import React from 'react';
import Wrapper from './StyledPage';

export const Intranet = () => {
  return <Wrapper>Intranet</Wrapper>;
};
